"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcSlider = _interopRequireDefault(require("rc-slider"));
require("rc-slider/assets/index.css");
var _get = _interopRequireDefault(require("lodash/get"));
var _styles = require("./styles");
var _excluded = ["handles", "colorType"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var RangeInput = function RangeInput(_ref) {
  var handles = _ref.handles,
    colorType = _ref.colorType,
    props = _objectWithoutProperties(_ref, _excluded);
  var handle = function handle(handleProps) {
    var value = handleProps.value,
      max = handleProps.max,
      min = handleProps.min;
    var left = 100 / (handleProps.max - handleProps.min) * (handleProps.value - handleProps.min);
    var last = value === max;
    var first = value === min;
    return /*#__PURE__*/_react["default"].createElement(_styles.Handle, {
      style: {
        left: "".concat(left, "%")
      },
      colorType: colorType
    }, (0, _get["default"])(handles, "".concat(value, ".label")) && /*#__PURE__*/_react["default"].createElement(_styles.Tooltip, {
      last: last,
      first: first,
      colorType: colorType
    }, (0, _get["default"])(handles, "".concat(value, ".label"))), (0, _get["default"])(handles, "".concat(value, ".icon")));
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.SliderStyled, {
    colorType: colorType,
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement(_rcSlider["default"], _extends({
    handle: handle,
    colorType: colorType
  }, props)));
};
RangeInput.propTypes = {
  handles: _propTypes["default"].object,
  colorType: _propTypes["default"].string
};
var _default = exports["default"] = RangeInput;